import { RawSearchInput } from '../RawSearchInput';

import { defaultProps, Props } from './AutoSuggest.types';

export const AutoSuggest = <T,>(props: Props<T>) => {
  return <RawSearchInput disableClearable multiple {...props} />;
};

AutoSuggest.defaultProps = defaultProps;
